<template>
  <div 
    class="road"
    :style="{width: `${squareNum * 3.5}px`}"
  >
    <div 
      class="square"
      v-for="square in squareNum"
      :key="square"
      :class="{bottom: Math.random() > .5}"
      :style="{
        height: `${squareHeight * 2}px`,
        width: `${3.5}px`
      }"
    >
      <div 
        class="square-content"
        :style="{height: `${squareHeight}px`}"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SquaresRoad',
  props: {
    squareNum: {
      type: Number,
      default: 0,
    },
    squareHeight: {
      type: Number,
      default: 3,
    }
  },
}
</script>

<style scoped>
  .road {
    display: flex;
    margin: 5px 0px;
  }

  .road .square {
    display: flex;
    flex-direction: column;
  }

  .road .square.bottom {
    justify-content: flex-end;
  }

  .square-content {
    background-color: #262626;
  }
</style>